import React, { useCallback, useEffect, useState } from 'react'
import { useAppContext } from '../AppContext';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import func from '../services/functions';
import { RecieptModal, onGetReciept } from './OpenBanking/PaymentReceipt/RecieptsUtils';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

const WebSocket = () => {
    const {socketRef: [,setSocketRef],user:[user],reloadData:[reloadData,setReloadData],notificationsRefresh:[ , setNotificationsRefresh ]} = useAppContext()
    const token = func.getCookie("token")
    const [recieptModal,setRecieptModal]=useState({visible:false,data:null})
    const { t } = useTranslation('translations');

    const reload=useCallback(func.debounce(()=>{
        setReloadData(reloadData=>!reloadData)
    },100),[reloadData])

    const refreshPage = useCallback(
        func.debounce(() => {
            const refreshToast = toast.warn(
                t("openBanking.systemRefresh"),
                {
                  containerId:"all_toast",
                  autoClose: false,
                  type:"warning",
                  closeButton:false,
                  closeOnClick:false,
                }
              );

              setTimeout(()=>{
                  toast.dismiss(refreshToast);
                  window.location.reload(true);
              },15000)
        }, 100),
        []
      );



    useEffect(() => {
        const username = user.username; 
        if(!username  || !token) return
        const socket = new SockJS(`${process.env.REACT_APP_JAVA_SERVER_URL}public/notifications/`);
        const stompClient = Stomp.over(socket);
        setSocketRef(stompClient);




        stompClient.connect({ username,token}, () => {
            console.log('Web Socket is connected');
            // stompClient.subscribe('/topic/notification', (notification) => {
            //     const body=JSON.parse(notification?.body ?? "")
            // });
            stompClient.subscribe('/users/queue/messages', (notification)=>onGetReciept({notification,reload,setRecieptModal}));
            stompClient.subscribe('/users/queue/notification', (notification) => {
                const body=JSON.parse(notification?.body ?? "")
                console.log({body})
                setNotificationsRefresh(notificationsRefresh => !notificationsRefresh);
                const { type, title,message } = body;
                const toastContent = (
                    <div>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                                icon={faBell}
                                className="mr-2"
                                style={{
                                    color: "#495057"
                                }}
                            />
                            <div style={{fontWeight:700,color:"#495057"}}>{t(`navbar.${type.toLowerCase()}Notification`, title || "Notification")}</div>
                        </div>
                        {message?.length>0 && <description style={{ fontSize: '14px', lineHeight: 1.0, color: '#495057',fontWeight:600 }}>
                            {message}
                        </description>
                        }
                </div>

                );

                toast.success(toastContent, {
                    containerId: "all_toast",
                    position: "bottom-right",
                    icon:false,
                    hideProgressBar: true,
                });
                });
            stompClient.subscribe('/topic/refresh', ()=>{refreshPage() } );
       
            stompClient.send('/users/queue/notification',{}, JSON.stringify({
                name: user.username,
                message:"Update",
            }));
        });

        return () => {
            if(stompClient && stompClient.connected)
            stompClient.disconnect();
        };
    }, [user.username,token,setSocketRef,]); //
    

    // const onMessage = ({title="Notification",text,icon="info"}) => {
    //     Swal.fire({
    //         title: 'Notification',
    //         text: msg.message,
    //         icon: 'info'
    //     })
    // }
    return <RecieptModal recieptModal={recieptModal} setRecieptModal={setRecieptModal}/>
}

export default WebSocket